// extracted by mini-css-extract-plugin
export default {"primaryBackground":"#1fab1c","ctaBackground":"#f06800","secondaryBackground":"rgba(0, 0, 0, 0.2)","ghostBackground":"transparent","dangerBackground":"#ef3f2a","textColor":"#fff"};